module.exports = __webpack_public_path__ + "img/gb-whatsapp-ban-issue.b6c53e02.webp";